import { DateInput } from "../../../types";
import {
  DatePicker,
  DateTimeValidationError,
  PickerChangeHandlerContext,
} from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

type Props = {
  field: DateInput;
  fieldName: string;
  handleChange: (field: DateInput) => void;
  disabled: boolean;
  minDate?: Dayjs;
  maxDate?: Dayjs;
};

const FormDateInput = ({
  field,
  fieldName,
  handleChange,
  disabled,
  minDate,
  maxDate,
}: Props) => {
  function handleInputChange(
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateTimeValidationError>
  ) {
    let _field = { ...field };
    if (value === null) {
      _field.value = null;
      _field.error = "Ce champ est requis";
    } else {
      _field.error = "";
      _field.value = value;
    }
    handleChange(_field);
  }

  return (
    <DatePicker
      name={fieldName}
      value={field.value}
      timezone="America/New_York"
      onChange={handleInputChange}
      label={field.label}
      maxDate={maxDate}
      minDate={minDate}
      format={field.format ? field.format : "YYYY-MM-DD"}
      shouldDisableDate={field.shouldDisableDate}
      shouldDisableMonth={field.shouldDisabledMonth}
      disablePast={field.disablePast}
      disableFuture={field.disableFuture}
      disabled={disabled}
      views={field.views}
      sx={{
        sx: {
          ".MuiInputLabel-asterisk": field.required
            ? { color: "#A81B8D", fontSize: "20px" }
            : {},
        },
      }}
      slotProps={{
        field: {
          readOnly: true,
        },
        textField: {
          required: field.required,
          fullWidth: true,
          error: !(field.error === ""),
          helperText: field.error ? field.error : field.helperText,
          InputLabelProps: {
            required: field.required,
          },
        },
      }}
    />
  );
};
export default FormDateInput;
